import { WISE, APM, EMBED_POST_MESSAGE_TYPES, payMethodMap } from '@/views/checkout/payment/helper/constant';
import { flowTypes, pageConfig } from '@/common/service/page-config';
import store from '@/store';
import { getPlanTypeByCategory } from '@/common/service/parse';
import { planTypes } from '@/common/constants';
import { isDebug } from '@/utils';
import Vue from 'vue';

export const apmPaymentType = (paymentMethodName = '', imageFileName) => {
  if (paymentMethodName === WISE) {
    const wisePaymentName = getWisePaymentName(imageFileName);
    return `apm-${wisePaymentName}`;
  }
  return `apm-${paymentMethodName}`;
};

export const getWisePaymentName = (imageFileName) => {
  const wiseSubstr = `${WISE}-`;
  return imageFileName.substring(imageFileName.indexOf(wiseSubstr) + wiseSubstr.length).toLowerCase();
};

export const getApmGaTrackingName = (paymentMethodName, imageFileName) => {
  if (paymentMethodName === WISE) {
    return imageFileName.replace(WISE, APM).toLowerCase();
  }
  return `${APM}-${paymentMethodName}`.toLowerCase();
};

export const checkIfSwitchFlow = (currentFlowType) => {
  return currentFlowType === flowTypes.switch;
};

export const checkIfPaidToPaidFlow = (currentFlowType) => {
  const { planType, oldPlanCode } = pageConfig.editConfig;
  const { boughtPlans, getSelectedPlans } = store.getters;
  const currentSelectedPlan = getSelectedPlans.find((item) => item.type === planType);
  const currentBoughtPlan = boughtPlans.find((item) => item.plan_code === oldPlanCode);
  const isZoBasicPlusUpgrade =
    currentSelectedPlan && currentBoughtPlan
      ? getPlanTypeByCategory(currentSelectedPlan?.category) === planTypes.ZOOM_MEETING &&
        getPlanTypeByCategory(currentBoughtPlan?.category) === planTypes.ZONE_BASIC_PLUS
      : false;
  return (
    [flowTypes.edit, flowTypes.add2cart, flowTypes.pro2biz, flowTypes.downgrade, flowTypes.biz2pro].includes(currentFlowType) ||
    (currentFlowType === flowTypes.upgrade &&
      !!isZoBasicPlusUpgrade) /* when the flow type is upgrade, only from zobasicplus to meeting plan is the P2P flow*/
  );
};

export const isAdd2CartFlow = () => {
  return window.$context.is.add2cart && window.$context.is.addPage;
}

// ALTERNATIVE CREDIT CARD FOR ZUORA OUTAGE - for postMessage communicate with APM project
export class EmbedMessager {
  fromOrigin = ''
  callbackList = []
  constructor(origin = '') {
    this.fromOrigin = origin;
    this.callbackList = [];
    // reset in advance
    this.destroy();
    window.addEventListener(
      'message',
      this.messageCallback,
      false,
    );
  }
  messageCallback = (event) => {
    if (this.fromOrigin && event.origin !== this.fromOrigin) return;
    isDebug && console.log('payload data from APM: ', event.data);
    if(event.data.type === EMBED_POST_MESSAGE_TYPES.ERROR) {
      Vue.prototype.$message.error({
        duration: 10000,
        message: Vue.prototype.$t('billing.payment.apm_payment_error'),
        showClose: true
      });
    }
    if(this.callbackList.length > 0) this.callbackList.map((callback) => { callback(event); });
  }
  listen(callback = () => {}, origin = window?.location?.origin) {
    this.fromOrigin = origin;
    this.callbackList.push(callback);
  }
  send(data, origin = window?.location?.origin, targetWindow = window){
    if(targetWindow && targetWindow.postMessage) {
      targetWindow.postMessage(data, origin);
    }
  }
  destroy() {
    window.removeEventListener(
      'message',
      this.messageCallback,
      false,
    );
  }
}

export const isPaymentMethodCreditCard = (selectedPaymentMethod, curPaymentMethod) => {
  return selectedPaymentMethod === payMethodMap.credit ||
    selectedPaymentMethod === payMethodMap.creditByIndia ||
    (selectedPaymentMethod === null && curPaymentMethod === payMethodMap.credit) ||
    (selectedPaymentMethod === null && curPaymentMethod === payMethodMap.creditByIndia);
}

export const isPaymentMethodUpi = (selectedPaymentMethod, curPaymentMethod) => {
  return (selectedPaymentMethod === payMethodMap.upi) ||
    (selectedPaymentMethod === null && curPaymentMethod === payMethodMap.upi);
}


